export default "__VITE_ASSET__5d12230c__"